module.exports = __webpack_public_path__ + "img/waste_basket.df983a28.svg";